import { isEmpty, toLower } from 'lodash';
import { useContext } from 'react';
import { DWTCContext } from '../utils/context';

export function getTranslationByKey(list, key) {
  const { langCode } = useContext(DWTCContext);
  const isArabic = langCode === 'ar';

  if (isEmpty(list)) return key;
  const filteredItem = list.find(({ key: listKey }) => toLower(listKey) === toLower(key));
  if (isEmpty(filteredItem)) return key;
  if (isArabic) return filteredItem.value;
  return filteredItem.key;
}

export function getTranslationByKeys(list, keys) {
  const { langCode } = useContext(DWTCContext);
  const isArabic = langCode === 'ar';

  if (isArabic)
    return list.reduce((acc, curr) => {
      if (keys.indexOf(curr.key) > -1) acc.push(curr);
      return acc;
    }, []);
  return keys;
}
